const STORAGE_KEY = "postLoginRedirect";

const AUTH_PATHS = ["/login", "/reset-password", "/activate", "/change-password"];

export function sanitizeRedirectPath(path?: string | null): string | null {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) {
    return null;
  }
  const pathname = path.split(/[?#]/)[0];
  return AUTH_PATHS.includes(pathname) ? null : path;
}

export function setPostLoginRedirect(path?: string | null): void {
  const safePath = sanitizeRedirectPath(path);
  if (!safePath) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, safePath);
  } catch {
    // private-mode browsers can reject sessionStorage writes
  }
}

export function consumePostLoginRedirect(): string | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return sanitizeRedirectPath(stored);
  } catch {
    return null;
  }
}
